import { createAction, props } from "@ngrx/store";
import { MachineListFilter } from "./machine-list-filter.model";

export const setMachineListFilter = createAction(
  '[MachineListFilter] Set Machine List Filter',
  props<{ filter: MachineListFilter }>()
);